import React from 'react';
import { Flex, FlexProps, Icon } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { NavLink } from 'react-router-dom';

interface SidebarItemProps extends FlexProps {
  icon: IconType;
  to: string;
  children: React.ReactNode;
}

function SidebarItem({ icon, to, children }: SidebarItemProps) {
  return (
    <NavLink to={to} style={{ textDecoration: 'none' }}>
      {({ isActive }) => (
        <Flex
          align="center"
          p="2"
          mx="4"
          borderRadius="lg"
          role="group"
          cursor="pointer"
          _hover={{ bg: 'teal.400', color: 'white' }}
          fontWeight={isActive ? 'bold' : 'normal'}
          color={isActive ? 'teal' : 'inherit'}
        >
          <Icon mr="4" fontSize="16" _groupHover={{ color: 'white' }} as={icon} />
          {children}
        </Flex>
      )}
    </NavLink>
  );
}

export default SidebarItem;
